import React, { ReactNode } from 'react'
import { Accordion, AccordionDetails, AccordionSummary } from '@mui/material';
import DrawerItem from '../Item/drawerItem';
import { DrawerItemTypes } from '../../../../Interfaces/componentTypes';

interface IProps {
    itemTitle: string,
    itemIcon: string,
    children: ReactNode,
    titleStyle?:string
}

const DrawerAccordion: React.FC<IProps> = (props) => {
    const { itemIcon, itemTitle, children,titleStyle } = props;
    const [expanded, setExpanded] = React.useState<string | false>(false);

    const handleChange =
        (panel: string) => (event: React.SyntheticEvent, isExpanded: boolean) => {
            setExpanded(isExpanded ? panel : false);
        };

    return (
        <div className='drawerAccordion'>
            <Accordion expanded={expanded === 'panel1'} onChange={handleChange('panel1')}>
                <AccordionSummary
                    aria-controls="panel1bh-content"
                    id="panel1bh-header"
                >
                    <DrawerItem
                        onClick={() => { }}
                        title={itemTitle}
                        icon={itemIcon}
                        titleStyle={titleStyle}
                        type={DrawerItemTypes.ACCORDEON}
                    />
                </AccordionSummary>
                <AccordionDetails>
                    {children}
                </AccordionDetails>
            </Accordion>
        </div>
    )
};

export default DrawerAccordion
